<template>
  <div id="page" class="bg-light">
    <b-card class="create-form container" :header="'Modification'" header-tag="h3">
      <form v-if="dataLoaded" v-on:submit.prevent>
        <vue-form-generator :schema="formSchema" :model="formModel" ></vue-form-generator>
      </form>
    </b-card>
  </div>
</template>

<script>
import navbar from '@/components/backoffice/navbar.vue'
import axios from 'axios'
import bTabs from 'bootstrap-vue/es/components/tabs/tabs'
import bCard from 'bootstrap-vue/es/components/card/card'
import CommonApi from '@/api/commonApi'
import Row from '@/components/backoffice/show/tabs/row.vue'
import textComponent from '@/components/backoffice/type/text.vue'
import fontAwesome from '@/components/global/icon/fontAwesome.vue'
import bButton from 'bootstrap-vue/es/components/button/button'
import buttonGroup from '@/components/backoffice/button/group.vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import crypto from 'crypto'

export default {
  components: {
    buttonGroup,
    bButton,
    fontAwesome,
    Row,
    textComponent,
    bCard,
    bTabs,
    'vue-form-generator': VueFormGenerator.component
  },

  data () {
    return {
      dataLoaded: false,
      rows: [

      ],
      buttons: [
      ],
      positioningClues: { position: 'right', overall: {} },
      formModel: {},
      formSchema: {},
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: false
      }
    }
  },

  created () {
    this.errorTitle = this.$t('error.error')
    this.errorMsg = this.$t('error.error')
    let commonApi = new CommonApi()
    commonApi.getCBConfigurations()
      .then(cbDatas => {
        this.formModel = cbDatas.data.data
        this.formSchema['fields'] = []
        for (const name of Object.keys(cbDatas.data.data)) {
          let field = {}
          field['type'] = 'input'
          field['inputType'] = 'text'
          field['label'] = this.$t('cbConfiguration.' + name)
          field['model'] = name
          field['id'] = name
          field['name'] = name
          field['required'] = true
          if (name === 'card_amex_expiry') {
            field['pattern'] = '^\\d{2}\\/\\d{2}$'
          }

          // Décommenter si il y a besoin d'afficher un texte contenant les anciennes valeurs
          /* if (this.formModel[name].includes('*')) {
            field['placeholder'] = this.formModel[name]
            field['required'] = false
            this.formModel[name] = ''
          } else {
            field['required'] = true
          } */
          this.formModel[name] = ''
          this.formSchema['fields'].push(field)
        }
        this.formSchema.fields.push({
          type: 'submit',
          buttonText: 'Enregistrer',
          onSubmit: this.submitForm,
          styleClasses: 'float-right ml-1 mr-1 field-submit',
          attributes: {
            input: {
              class: 'btn btn-secondary bg-secondary'
            }
          }
        })
        this.dataLoaded = true
      })
  },

  methods: {
    getWidth (row) {
      if (row.length === 1) {
        return 'large'
      }
      return 'small'
    },

    async submitForm () {
      for (const name of Object.keys(this.formModel)) {
        this.formModel[name] = document.getElementById(name).value
        if (this.formModel[name] === '') {
          return
        }
      }
      // Creating the last digits sequence
      if (this.formModel['card_amex_number'] !== undefined && this.formModel['card_amex_number'] !== '') {
        this.formModel['card_amex_number_last_digits'] = this.formModel['card_amex_number'].substring(this.formModel['card_amex_number'].length - 4)
      }

      let publicKey = await this.retrievingPublicKey()

      let dataToSend = JSON.parse(JSON.stringify(this.formModel))
      dataToSend['card_amex_number'] = this.encryptData(this.formModel['card_amex_number'], publicKey)
      dataToSend['card_amex_crypto'] = this.encryptData(this.formModel['card_amex_crypto'], publicKey)
      axios.patch('/api/configurations/cb/edit', dataToSend)
        .then(response => {
          this.$router.push({ name: 'admin_cb' })
        })
        .catch(error => {
          console.log(error)
        })
    },

    async retrievingPublicKey () {
      let commonApi = new CommonApi()
      let dataReceived = await commonApi.getCBPublicKey()
      return dataReceived.data.data.key
    },

    encryptData (data, publicKey) {
      let encryptedData = crypto.publicEncrypt({ key: publicKey, padding: crypto.constants.RSA_PKCS1_PADDING }, Buffer.from(data))
      return encryptedData.toString('base64')
    },

    goBack () {

    }
  }
}
</script>

<style lang="scss">
html {
  position: relative;
  min-height: 100%;
}
.back-layout {
  padding-bottom: 80px;
  @import '../../../../assets/sass/backoffice/main';
}
.from-group.field-submit input {

}
</style>
